import React from 'react'
import PropTypes from 'prop-types'

import Tombstone from './components/Tombstone'

import * as Styled from './TombstonesList.styles'

const TombstoneList = ({ data, 'data-test': dataTest }) => {
  const tombstones = data.map((tombstoneData, index) => <Tombstone key={index} data={tombstoneData} />)
  return <Styled.List data-test={dataTest}>{tombstones}</Styled.List>
}

TombstoneList.propTypes = {
  /**
   * Tombstone nutritional data
   */
  data: PropTypes.shape({ data: PropTypes.array }).isRequired,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string
}

TombstoneList.defaultProps = {
  'data-test': 'tombstone-list'
}

export default TombstoneList
